// @flow

/* -----------------Types--------------- */
import { parseTime } from '../simpleUtils';

const summarizeGame = (
  scores: number[],
  startTime: ?string,
  endTime: ?string,
) => {
  const start = parseTime(startTime);
  const end = parseTime(endTime);
  const timePerAnswer = scores.length > 0 ? (end - start) / (1000.0 * scores.length) : 0;

  return {
    timePerAnswer,
  };
};

export {
  // eslint-disable-next-line import/prefer-default-export
  summarizeGame,
};
